import React, { Component } from 'react';
import axios from '../../axios-orders';
import { connect } from 'react-redux';

import classes from './Orders.module.css';

import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import Spinner from '../../components/UI/Spinner/Spinner';
import Order from '../../components/Order/Order';
import FlashMessage from '../FlashMessage/FlashMessage';
import * as actionCreator from '../../store/actions/index';

class Orders extends Component {
	componentDidMount() {
		this.props.fetchedOrdersHandler(this.props.token);
	}

	render() {
		let flashMessage = null;
		if (this.props.error) {
			flashMessage = (
				<FlashMessage type="Error" duration={5000}>
					<p>{this.props.error.message}</p>
				</FlashMessage>
			);
		}

		const orders = this.props.loading ? (
			<Spinner />
		) : this.props.orders.length > 0 ? (
			this.props.orders.map((orderData) => (
				<Order
					key={orderData._id}
					ingredients={orderData.ingredients}
					price={orderData.price}
				/>
			))
		) : (
			<div className={classes.Empty}>
				<p>You have no previous orders</p>
			</div>
		);
		return (
			<div className={classes.AllOrders}>
				{flashMessage}
				{orders}
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		error: state.order.error,
		orders: state.order.orders,
		loading: state.order.loading,
		token: state.auth.token,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchedOrdersHandler: (token) => dispatch(actionCreator.fetchOrders(token)),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withErrorHandler(Orders, axios));
